const _ = 6, R = 6, E = 12, u = 230, W = {
  arrowLeft: 50,
  arrowTop: 99,
  arrowTransform: "translate(-50%, -50)",
  placement: "top",
  rotate: 135,
  tooltipInitialPosition: "translate3d(0, 0, 0)",
  tooltipPosition: "translate3d(0, 0, 0)"
}, S = ({
  childrenStructuredRef: e,
  tooltipStructuredRef: c
}) => {
  const {
    top: T,
    left: a,
    right: s
  } = e, {
    width: l,
    height: i
  } = c;
  return T - i - 12 < 0 ? "bottom" : a - l - 12 < 0 ? "right" : s + l + 12 > window.innerWidth ? "left" : "top";
}, f = ({
  placement: e,
  childrenRef: c,
  tooltipRef: T
}) => {
  const a = c.current.getBoundingClientRect(), s = T.current.getBoundingClientRect(), l = e === "auto" ? S({
    childrenStructuredRef: a,
    tooltipStructuredRef: s
  }) : e, {
    top: i,
    left: d,
    right: P,
    width: h,
    height: A
  } = a, {
    width: n,
    height: r
  } = s, p = document.documentElement.scrollTop;
  switch (l) {
    case "bottom": {
      const t = d + h / 2 - n / 2, o = i + p + A + 6 + 6;
      return {
        arrowLeft: n / 2,
        arrowTop: -11,
        arrowTransform: "",
        placement: "bottom",
        rotate: 180,
        tooltipInitialPosition: `translate3d(${t}px, ${o - 12}px, 0)`,
        tooltipPosition: `translate3d(${t}px, ${o}px, 0)`
      };
    }
    case "left": {
      const t = d - n - 6 - 12, o = i + p - r / 2 + A / 2;
      return {
        arrowLeft: n + 6 + 5,
        arrowTop: r / 2,
        arrowTransform: "translate(-50%, -50%)",
        placement: "left",
        rotate: -90,
        tooltipInitialPosition: `translate3d(${t + 12}px, ${o}px, 0)`,
        tooltipPosition: `translate3d(${t}px, ${o}px, 0)`
      };
    }
    case "right": {
      const t = P + 6 + 12, o = i + p - r / 2 + A / 2;
      return {
        arrowLeft: -11,
        arrowTop: r / 2,
        arrowTransform: "translate(50%, -50%)",
        placement: "right",
        rotate: 90,
        tooltipInitialPosition: `translate3d(${t - 12}px, ${o}px, 0)`,
        tooltipPosition: `translate3d(${t}px, ${o}px, 0)`
      };
    }
    default: {
      const t = d + h / 2 - n / 2, o = i + p - r - 6 - 6;
      return {
        arrowLeft: n / 2,
        arrowTop: r - 1,
        arrowTransform: "",
        placement: "top",
        rotate: 0,
        tooltipInitialPosition: `translate3d(${t}px, ${o + 12}px, 0)`,
        tooltipPosition: `translate3d(${t}px, ${o}px, 0)`
      };
    }
  }
};
export {
  u as ANIMATION_DURATION,
  _ as ARROW_WIDTH,
  W as DEFAULT_POSITIONS,
  R as SPACE,
  E as TOTAL_USED_SPACE,
  S as computePlacement,
  f as computePositions
};
